module.exports = __webpack_public_path__ + "images/Copy text_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Copy text_hover.png
// module id = 384
// module chunks = 0 1